export default __webpack_public_path__ + "static/media/logo-black.061b8f2e.png";